import { createAction, props } from "@ngrx/store";
import { UserProfileAccountFavorite } from "src/app/common/services/api/userprofile/type/userprofile";

export const resolveFavoriteProjects = createAction(
  'Account.ResolveFavoriteProjects',
  props<{
    projects: UserProfileAccountFavorite[];
  }>()
);
